import axios from 'axios'
import * as types from "../mutation-types";
import {BigNumber} from 'bignumber.js';


const getDefaultState = () => {
    return {
        data: [],
        data_loaded: false,
        site_error: false,
        balance: 0,
        devices: null,
        last_payment: null,
    }
}

// // state
export const state = getDefaultState()

// getters
export const getters = {}

// mutations
export const mutations = {
    [types.GET_DASHBOARD](state, {dashboard, sum, devices, last_payment})
    {
        state.data = dashboard;
        state.data_loaded = true;
        state.balance = sum;
        state.devices = devices;
        state.last_payment = last_payment;
    },
    [types.GET_DASHBOARD_FAILURE](state)
    {
        state.dashboard = null;
        state.data_loaded = true;
        state.site_error = true;
        state.balance = 0;
        state.device = null;
        state.last_payment = null;
    },

    // [types.RESET_DASHBOARD] (state) {
    //
    //     Object.assign(state, getDefaultState())
    // }
}

// actions
export const actions = {
    async getDashboard({commit})
    {
        try
        {
            state.data_loaded = false;
            let {data} = await axios.post('/api/dashboard');
            let balance = parseFloat(data.transactions);
            balance = balance.toFixed(2);

            if (balance == -0.00)
            {
                balance = '0.00';
            }

            const devices = await axios.post('/api/devices', {'page' : 'dashboard'});

            commit(types.GET_DASHBOARD, {dashboard: data, sum: balance, devices: devices.data.devices, last_payment: data.last_payment})
        } catch (e)
        {
            commit(types.GET_DASHBOARD_FAILURE)
        }
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/dashboard.js